import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectAuthenticated, selectCurrentUser } from '../Login/selectors';
import Avatar from '../Avatar';
import { imageUrl } from '../services/helpers';
import { selectGamesWithNewMoves } from '../NewMoves/reducer';
import { Header, Home, Logo, Nav, NewMovesDot } from './styled';

const MainMenu = () => {
  const authenticated = useSelector(selectAuthenticated);
  const user = useSelector(selectCurrentUser);
  const gamesWithNewMoves = useSelector(selectGamesWithNewMoves);
  const label = gamesWithNewMoves ? `Your games: ${gamesWithNewMoves} with new moves` : 'Pokémon TCG home';

  return (
    <Header>
      {/* Home is your games; the dot says some have moves you haven't seen. */}
      <Home to="/" aria-label={label}>
        <Logo src={imageUrl('/pokemon-tcg-logo.png')} alt="Pokémon Trading Card Game" />
        {authenticated && gamesWithNewMoves > 0 && <NewMovesDot aria-hidden="true">{gamesWithNewMoves}</NewMovesDot>}
      </Home>
      {authenticated && (
        <Nav>
          <Link to="/cards">Cards</Link>
          <Link to="/decks">Decks</Link>
          <Link to="/rules">Rules</Link>
          <Link to="/profile" aria-label="Profile"><Avatar user={user} size={30} /></Link>
        </Nav>
      )}
    </Header>
  );
};

export default MainMenu;
